module.exports = __webpack_public_path__ + "static/quiniela_poceada-ca7af302452e2bf4872e74583a9f27e3.svg";